<template>
    <div class="info-model">
        <div class="overlay" @click="closeReprintModal"></div>

        <div class="modal-body" :class="{ 'pulledUp': visible }">
            <div class="title-box">
                <h2>{{ getString('reimpressao_cupom_fiscal') }}</h2>
            </div>
            <div class="search-bar">
                <label for="search-bar-date" v-text="getString('data_dois_pontos')"></label>
                <input class="date-input" type="text" id="search-bar-date" inputmode="numeric" v-model="rawSearchDate" data-layout="numeric"
                    autocomplete="off" @input="handleDateInput" @focus="show" placeholder="DD/MM/AAAA" v-mask="dataMask">

                <label for="search-bar-text" v-text="getString('pesquisar')"></label>
                <input class="search-input" type="text" id="search-bar-text" v-model="rawSearchText" data-layout="numeric"
                    autocomplete="off" @input="handleSearch" @focus="show">
            </div>

            <div class="main-area">
                <div v-if="couponToVisualize" class="screen-printed">
                    <pre>{{ couponToVisualize }}</pre>
                </div>
                <div v-else class="sale-type-radios">
                    <table class="sales-table">
                        <thead>
                            <tr>
                                <th> </th>
                                <th> DATA </th>
                                <th> N° CUPOM FISCAL </th>
                                <th> VALOR </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(coupon, key) in filteredList" :key="key">
                                <td>
                                    <div class="container-input">
                                        <input class="styled-input" :id="'reprint' + key" type="checkbox" :value="coupon"
                                            v-model="selectedCoupon" @change="selectedCouponChange(coupon, $event)">
                                        <label class="checkmark radio" :for="'reprint' + key"></label>
                                    </div>
                                </td>
                                <td> <label :for="'reprint' + key"> {{ coupon.saleDate.replace(/-/g, '/') + ' ' + coupon.hour }} </label></td>
                                <td> <label :for="'reprint' + key"> {{ coupon.nfceCode }} </label></td>
                                <td> <label :for="'reprint' + key"> {{ formatMoney(coupon.value) }} </label></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="footer-area">
                <DefaultButton v-if="couponToVisualize" :text="getString('voltar')" @defaultBtnClick="backToList()"></DefaultButton>
                <DefaultButton v-else :disabled="disableReprint" :text="getString('visualizar')" @defaultBtnClick="visualizeCoupon()"></DefaultButton>
                <DefaultButton :disabled="disableReprint" :text="getString('imprimir')" @defaultBtnClick="hasTefCoupon()"></DefaultButton>
                <!-- <DefaultButton :disabled="disableReprint" :text="getString('Imprimir comprovante TEF')" @defaultBtnClick="reprintTef()"></DefaultButton> -->
                <DefaultButton v-if="hasPermission('cancelSale')" :disabled="disableReprint" :text="getString('cancelar_venda')" @defaultBtnClick="cancelSale()"></DefaultButton>
            </div>
        </div>
        <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input"/>
    </div>
</template>

<script>
/* eslint-disable no-return-await */
import Vue from 'vue'
import VueTouchKeyboard from 'vue-touch-keyboard'
import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import DefaultButton from '@/components/DefaultButton'
import LocaleController from '@/assets/controllers/LocaleController'
import PrinterController from '@/assets/controllers/PrinterController'
import requestModule from '@/assets/libs/requestModule'
import Util from '@/assets/libs/util'
import eventModule from '@/assets/libs/eventModule'
import PaymentController from '../assets/controllers/PaymentController'
import AccessController from '../assets/controllers/AccessController'

Vue.use(VueTouchKeyboard)
Vue.use(style)

export default {
    name: 'ReprintModal',
    components: {
        DefaultButton,
        'vue-touch-keyboard': VueTouchKeyboard.component
    },
    mounted () {
        this.handleDateInput()
    },
    data () {
        return {
            visible: false,
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            layout: keyboardLayout.EXTENDED_NUMERIC_NO_NEXT,
            input: null,
            rawSearchDate: (() => {
                const d = new Date()
                const dd = String(d.getDate()).padStart(2, '0')
                const mm = String(d.getMonth() + 1).padStart(2, '0')
                return `${dd}/${mm}/${d.getFullYear()}`
            })(),
            rawSearchText: '',
            bkpCouponList: [],
            filteredList: [],
            selectedCoupon: [],
            disableReprint: true,
            couponToVisualize: '',
            cancelParams: {},
            dataMask: '##/##/####',
            couponToPrint: null
        }
    },
    props: [''],
    created () {
        eventModule.$on('refreshCoupons', this.handleDateInput)
    },
    beforeDestroy () {
        eventModule.$off('refreshCoupons', this.handleDateInput)
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        closeReprintModal: function () {
            this.$emit('closeReprintModal')
        },
        accept: function (text) {
            this.hide()
        },
        hide: function () {
            this.visible = false
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        backToList: function () {
            this.couponToVisualize = ''
        },
        visualizeCoupon: async function () {
            if (!this.disableReprint) {
                this.disableReprint = true

                if (this.couponDataIsComplete(this.couponToPrint)) {
                    let printOnScreen = true
                    let printOnScreenText = await PrinterController.printFiscal(this.couponToPrint.saleData.xml, this.couponToPrint.saleData,
                        this.couponToPrint.paymentMethod, this.couponToPrint.paymentNumber, printOnScreen, this.couponToPrint.saleDescription)
                    this.couponToVisualize = printOnScreenText
                } else {
                    Util.showInfoModal(this.getString('falha_cupom_interface'))
                }
                this.disableReprint = false
            }
        },
        reprintCoupon: async function () {
            if (!this.disableReprint) {
                this.disableReprint = true
                this.couponToPrint = await this.getCouponDetailsFromInterface()

                if (this.couponDataIsComplete(this.couponToPrint)) {
                    let printOnScreen = false
                    let printFiscalResult = await PrinterController.printFiscal(this.couponToPrint.saleData.xml, this.couponToPrint.saleData,
                        this.couponToPrint.paymentMethod, this.couponToPrint.paymentNumber, printOnScreen, this.couponToPrint.saleDescription)

                    if (!printFiscalResult || (printFiscalResult && printFiscalResult.data && printFiscalResult.data.error) || (printFiscalResult && printFiscalResult.error)) {
                        Util.showInfoModal(this.getString('falha_cupom_fiscal'))
                    }
                } else {
                    Util.showInfoModal(this.getString('falha_cupom_interface'))
                }
                this.disableReprint = false
            }
        },
        hasTefCoupon: async function () {
            let hasTefCoupon = this.couponToPrint && this.couponToPrint.saleData && this.couponToPrint.saleData.payments.some(payment => payment.nsu)
            if (hasTefCoupon) {
                Util.showConfirmationDialog(this.$modal, async () => {
                    await this.reprintCoupon()
                    await this.reprintTef()
                    return true
                }, this.getString('confirma_reimpressao_tef'), async () => {
                    await this.reprintCoupon()
                    return true
                })
                this.disableReprint = false
                return true
            }
            await this.reprintCoupon()
        },
        getCouponDetailsFromInterface: async function () {
            let payload = {
                subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
                posCode: Util.getGeneralInfo()['posCode'],
                saleSeq: this.selectedCoupon[0].saleSeq
            }

            return await requestModule.postRequest('sale/couponReprint', payload).then(res => {
                if (res && !res.error && res.data) {
                    return this.formatResponseData(res)
                }
                return null
            }).catch(error => {
                console.log(error.message)
                return null
            })
        },
        cancelSale: async function () {
            if (this.disableReprint) return
            this.disableReprint = true
            if (!this.couponToPrint || !this.couponToPrint.saleData) {
                Util.showInfoModal(this.getString('cancelamento_manual'))
                this.disableReprint = false
                return
            }
            let paymentTef = this.couponToPrint.saleData.payments.filter(e => e.nsu)
            if (paymentTef.length > 1) {
                Util.showInfoModal(this.getString('cancelamento_manual_mult_pag'))
                this.disableReprint = false
                return
            }
            if (paymentTef.length === 0) {
                // não precisa cancelar no tef somente a venda
                Util.showConfirmationDialog(this.$modal, () => {
                    this.cancelSaleDirectly(this.couponToPrint.saleData.nfceCode)
                }, this.getString('confirma_cancelamento'))
            } else {
                this.cancelParams = {
                    nsu: paymentTef[0].nsu,
                    nfceCode: this.couponToPrint.saleData.nfceCode,
                    saleDate: this.couponToPrint.saleData.saleDate,
                    saleValue: paymentTef[0].value,
                    saleType: paymentTef[0].paymentType
                }
                this.$emit('cancelTef', this.cancelParams)
            }
            this.disableReprint = false
        },
        cancelSaleDirectly: async function (nfceCode) {
            this.disableReprint = true
            let result = await PaymentController.cancelSale(nfceCode)
            if (result) {
                Util.showInfoModal(this.getString('cancelamneto_realizado'))
                this.handleDateInput()
            }
            this.disableReprint = true
        },
        formatResponseData: function (response) {
            try {
                let couponToPrint = {
                    saleData: response.data,
                    paymentMethod: {
                        NMTIPORECE: ''
                    },
                    paymentNumber: '',
                    saleDescription: response.data.saleDescription
                }

                if (response.data.payments.length === 1) {
                    couponToPrint.paymentMethod.NMTIPORECE = response.data.payments[0].paymentName
                    couponToPrint.paymentNumber = response.data.payments[0].nsu
                } else {
                    // O array payments só vai possuir mais de um elemento em caso de pagamento complementado.
                    // Nesse caso, o TAA imprime na nota original sempre o pagamento principal
                    let principalPayment = response.data.payments.find(element => element.paymentType === '9' || element.paymentType === 'A')
                    couponToPrint.paymentMethod.NMTIPORECE = principalPayment.paymentName
                }

                return couponToPrint
            } catch (error) {
                console.log(error.message)
                return {}
            }
        },
        couponDataIsComplete: function (couponToPrint) {
            return couponToPrint && couponToPrint.saleData && couponToPrint.saleData.xml && couponToPrint.paymentMethod &&
                couponToPrint.paymentMethod.NMTIPORECE
        },
        handleDateInput: function () {
            let sanitizedDate = this.rawSearchDate.replace(/\D/g, '')
            if (sanitizedDate.length === 8) this.getCouponListFromInterface(sanitizedDate)
        },
        getCouponListFromInterface: async function (sanitizedDate) {
            this.clearCouponData()
            this.refreshControls()
            let formattedSaleDate = `${sanitizedDate.substring(0, 2)}-${sanitizedDate.substring(2, 4)}-${sanitizedDate.substring(4, 8)}`

            let payload = {
                subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
                posCode: Util.getGeneralInfo()['posCode'],
                saleDate: formattedSaleDate
            }

            await requestModule.postRequest('sale/getSalesHistoryByPos', payload).then(res => {
                if (res && !res.error && res.data && res.data.length > 0) {
                    this.bkpCouponList = this.orderCouponsByNumber(res.data)
                } else {
                    this.bkpCouponList = []
                    if (res && res.error && res.message) {
                        Util.showInfoModal(res.message)
                    }
                }
            }).catch(error => {
                console.log(error.message)
                this.bkpCouponList = []
            })

            this.filteredList = Util.deepCopy(this.bkpCouponList)
        },
        clearCouponData: function () {
            this.selectedCoupon = []
            this.bkpCouponList = []
            this.filteredList = []
            this.rawSearchText = ''
            this.couponToVisualize = ''
            this.hide()
        },
        orderCouponsByNumber: function (couponsList) {
            return couponsList.sort((a, b) => a.nfceCode - b.nfceCode)
        },
        selectedCouponChange: async function (coupon, event) {
            this.selectedCoupon = []
            if (event && event.srcElement.checked) {
                this.disableReprint = true
                this.couponToPrint = null
                this.selectedCoupon.push(coupon)
                this.hide()
                this.couponToPrint = await this.getCouponDetailsFromInterface()
            }
            this.disableReprint = false
            this.refreshControls()
        },
        refreshControls: function () {
            this.disableReprint = this.selectedCoupon.length === 0
        },
        buildLabelText: function (coupon) {
            let text = coupon.saleDate.replace(/-/g, '/') + ' ' + coupon.hour + ' | ' + coupon.nfceCode + ' | '
            text += Util.formatMoney(coupon.value)
            return text
        },
        formatMoney: function (value) {
            return Util.formatMoney(value)
        },
        handleSearch: function () {
            this.filteredList = Util.deepCopy(this.bkpCouponList)
            if (this.rawSearchText !== '') this.applySearchCriteria()
        },
        applySearchCriteria: function () {
            this.filteredList = this.filteredList.filter(coupon => coupon.nfceCode.includes(this.rawSearchText))
        },
        hasPermission: function (permission) {
            return AccessController.getPermission(permission)
        },
        reprintTef: async function () {
            this.disableReprint = true
            // let couponToCancel = await this.getCouponDetailsFromInterface()
            if (!this.couponToPrint || !this.couponToPrint.saleData) {
                Util.showInfoModal(this.getString('nao_ha_dados_tef'))
                this.disableReprint = false
                return
            }
            let paymentTef = this.couponToPrint.saleData.payments.filter(e => e.nsu)
            this.reprintParams = {
                nsu: paymentTef[0].nsu,
                nfceCode: this.couponToPrint.saleData.nfceCode,
                saleDate: this.couponToPrint.saleData.saleDate,
                saleValue: paymentTef[0].value,
                saleType: paymentTef[0].paymentType
            }
            PaymentController.setCancelTefData(paymentTef[0].nsu, this.couponToPrint.saleData.saleDate, paymentTef[0].value)
            this.$emit('reprintTef', this.reprintParams)
            this.disableReprint = false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .info-model{
        .modal-body {
            pointer-events: auto;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 10;
            display: flex;
            flex-direction: column;
            background: white;
            max-height: 1300px;
            max-width: 900px;
            margin: auto;
            border-radius: 10px;

            .title-box {
                background-color: @primary-color;
                min-height: 120px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 10px 10px 0px 0px;

                h2 {
                    color: @white;
                    margin: auto;
                    text-align: center;
                    font-size: 50px;
                }
            }

            .search-bar {
                background-color: @primary-light;
                min-height: 80px;
                color: @white;
                display: flex;
                flex-direction: row;
                justify-content: space-evenly;
                align-items: center;

                input {
                    width: 160px;
                    height: 40px;
                    font-size: 30px;
                    padding: 5px 15px;
                    border: 2px solid @primary-color;
                    outline: none;
                }
                input::placeholder {
                    font-size: 25px;
                }
                .date-input {
                    width: 160px;
                }
                .search-input {
                    width: 250px;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                overflow: hidden auto;
                padding-left: 25px;

                .screen-printed {
                    font-size: 25px;
                    margin: auto;
                }

                .sale-type-radios {
                    .option {
                        display: flex;
                        margin-top: 15px;
                        align-items: center;
                        grid-template-columns: 20% 80%;
                    }
                }

                .label-text {
                    font-size: 30px;
                }
                .sales-table {
                    width: 98%;
                    th, td {
                        padding: 10px 5px;
                        text-align: center;
                    }
                    th {
                        font-weight: normal;
                        border-bottom: 1px solid black;
                    }
                    tr:nth-child(even) {
                        background-color: #f2f2f2;
                    }
                }
            }

            .footer-area {
                min-height: 140px;
                border-radius: 0px 0px 10px 10px;
                background: rgba(0, 0, 0, 0.1);
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-evenly;
                .button-default {
                    padding: 0 10px;
                    min-width: 240px !important;
                }
            }
        }

        .pulledUp {
            transform: translate(0, -100px);
        }
    }

    .overlay{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9;
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 0;
    }

    @media (max-width: 698px) {
        // Gertec SK210
        .info-model{
            .modal-body {
                max-height: 550px;
                max-width: 450px;

                .title-box {
                    min-height: 50px;
                    h2 {
                        font-size: 18px;
                    }
                }

                .search-bar {
                    min-height: 60px;
                    input {
                        font-size: 15px;
                        height: 30px;
                        padding: 0 10px;
                    }
                    label {
                        font-size: 18px;
                    }
                    input::placeholder {
                        font-size: 15px;
                    }
                    .date-input {
                        width: 90px;
                    }
                    .search-input {
                        width: 150px;
                    }
                }

                .main-area {
                    padding: 0 10px;
                    .screen-printed {
                        font-size: 15px;
                    }
                    .label-text {
                        font-size: 20px;
                    }
                }

                .footer-area {
                    min-height: 60px;
                    .button-default {
                        padding: 0 10px;
                        min-width: 130px !important;
                    }
                }
            }
        }
        #keyboard {
            max-width: 95%;
            font-size: 14px;
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) {
        // @tablet

        .info-model{
            .modal-body {
                max-height: 900px;
                max-width: 700px;

                .title-box {
                    min-height: 100px;
                    h2 {
                        font-size: 35px;
                    }
                }

                .footer-area {
                    min-height: 130px;
                    .button-default {
                        padding: 0 10px;
                        min-width: 200px !important;
                    }
                }
            }

            .pulledUp {
                transform: translate(0, -120px);
            }
        }

        #keyboard {
            max-width: 95%;
            font-size: 20px;
        }
    }
    @media (orientation: landscape) {
        .info-model{
            .modal-body {
                max-height: 585px;
                max-width: 750px;

                .title-box {
                    min-height: 50px;
                    h2 {
                        font-size: 25px;
                    }
                }

                .search-bar {
                    min-height: 60px;
                    input {
                        font-size: 20px;
                        height: 30px;
                        padding: 0 10px;
                    }
                    input::placeholder {
                        font-size: 15px;
                    }
                    .date-input {
                        width: 180px;
                    }
                    .search-input {
                        width: 250px;
                    }
                }

                .main-area {
                    .screen-printed {
                        font-size: 15px;
                    }
                    .label-text {
                        font-size: 20px;
                    }
                }

                .footer-area {
                    min-height: 60px;
                    .button-default {
                        max-height: 50px;
                    }
                }
            }
            .pulledUp {
                    transform: translate(0, 0);
                }
        }
        #keyboard {
            max-width: 720px;
            font-size: 18px;
            position: fixed;
            z-index: 10;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/ReprintModal.vue